module.exports = __webpack_public_path__ + "img/hr-straight-rail-horizontal-stone-path-remnants.1cb51da6.png";